import React from 'react';
import styled from 'styled-components';
import { UIProps } from '../../types/StyledProps';
import mergeClassNames from '../../lib/style-helpers/merge-class-name';
import UnstyledIcon, { StyledIconProps } from './unstyled-icon';
import { IconType } from './icon-type';

type IconProps = {
  type: IconType;
} & UIProps & StyledIconProps;

function Icon({
  className,
  type = IconType.Generic,
  ...props
}: React.PropsWithoutRef<IconProps>) {
  return (
    <StyledIcon
      type={type}
      className={mergeClassNames('Icon', className)}
      {...props}
    />
  );
}

export default Icon;

const StyledIcon = styled(UnstyledIcon)`
${({ theme }) => `
  position:${theme.icon.position};
  top: ${theme.icon.top};
  left: ${theme.icon.left};
  color: ${theme.colors.primary};
  `}  
`;
